<div [formGroup]="form">
  <div class="page-header">
    <h1>Review & Submit</h1>
  </div>
  <p>Please check the accuracy of the information entered in your application before submitting.</p>

  <section>
    <h2 class="blue-header">
      Overview <span class="hide-for-print"><button (click)="gotoPageIndex(pages.Overview);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
    </h2>
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>I am:</th>
          <td>{{ enumHelper.CompletingOnBehalfOf[valueForEnum('representativeInformation.completingOnBehalfOf')] }}
          </td>
        </tr>
      </tbody>
    </table>
    @if (form.get('introduction.understoodInformation').value === true) {
      <div>
        <p>
          <label class="inline-label inline-checkbox-label">
            <input type="checkbox" [checked]="form.get('introduction.understoodInformation').value === true" disabled="disabled" />
            <span>I have read and understood all the above information.</span>
          </label>
        </p>
      </div>
    }
  </section>

  <section>
    <h2 class="blue-header">
      Personal Information & Addresses <span class="hide-for-print"><button (click)="gotoPageIndex(pages.Personal);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
    </h2>
    <h3>Applicant Name</h3>
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>First Name</th>
          <td>{{ valueOrEmpty('personalInformation.firstName') }} </td>
        </tr>
        <tr>
          <th>Middle Name</th>
          <td>{{ valueOrEmpty('personalInformation.middleName') }} </td>
        </tr>
        <tr>
          <th>Last Name</th>
          <td>{{ valueOrEmpty('personalInformation.lastName') }} </td>
        </tr>
        <tr>
          <th>Other First Name</th>
          <td>{{ valueOrEmpty('personalInformation.otherFirstName') }} </td>
        </tr>
        <tr>
          <th>Other Last Name</th>
          <td>{{ valueOrEmpty('personalInformation.otherLastName') }} </td>
        </tr>
        <tr>
          <th>Date of Name Change</th>
          <td>{{ datesOrEmpty(['personalInformation.dateOfNameChange']) }}</td>
        </tr>
      </tbody>
    </table>

    <h3>Other Details</h3>
    <table class="table table-striped review-table">
      <tbody>
        @if (formType === ApplicationType.IFM_Application) {
          <tr>
            <th>Relationship to Victim</th>
            <td>{{ valueOrEmpty('personalInformation.relationshipToVictim') }}@if (form.get('personalInformation.relationshipToVictim').value === 'Other') {
              <span> :
              {{ valueOrEmpty('personalInformation.relationshipToVictimOther') }}</span>
            }</td>
          </tr>
        }
        @if (formType === ApplicationType.Witness_Application) {
          <tr>
            <th>Relationship to Victim</th>
            <td>{{ valueOrEmpty('personalInformation.relationshipToVictimOther') }}</td>
          </tr>
        }
        <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="false">
          <th>Gender</th>
          <td>{{ enumHelper.Gender[valueForEnum('personalInformation.gender')] }} </td>
        </tr>
        <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
          <th>Gender</th>
          <td>{{ enumHelper.Gender_V2[valueForEnum('personalInformation.gender')] }} </td>
        </tr>
        <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
          <th>Other Gender</th>
          <td>{{ valueOrEmpty('personalInformation.otherGender') }} </td>
        </tr>
        <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
          <th>Pronouns</th>
          <td>{{ enumHelper.Pronouns_V2[valueForEnum('personalInformation.pronouns')] }} </td>
        </tr>
        <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
          <th>Other Pronouns</th>
          <td>{{ valueOrEmpty('personalInformation.otherPronouns') }} </td>
        </tr>
        <tr>
          <th>Birth Date</th>
          <td>{{ datesOrEmpty(['personalInformation.birthDate']) }}</td>
        </tr>
        <tr>
          <th>Occupation</th>
          <td>{{ valueOrEmpty('personalInformation.occupation') }} </td>
        </tr>
        <tr>
          <th>Social Insurance Number (SIN)</th>
          <td>{{ valueOrEmpty('personalInformation.sin') }}</td>
        </tr>
        <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
          <th>Race/Ethnicity</th>
          <td>{{ enumHelper.RaceEthnicity_V2[valueForEnum('personalInformation.raceEthnicity')] }}
          </tr>
          <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
            <th>Other Race/Ethnicity</th>
            <td>{{ valueOrEmpty('personalInformation.otherRaceEthnicity') }} </td>
          </tr>
          <tr>
            <th>Do you identify as an Indigenous person?</th>
            <td>{{ getOptionSetNameFromVal(enumHelper.IndigenousStatus, valueOrEmpty('personalInformation.indigenousStatus')) }}</td>
          </tr>
          <tr>
            <th>Preferred Method of Contact</th>
            <td>{{ enumHelper.ApplicantPreferredMethodOfContact[valueForEnum('personalInformation.preferredMethodOfContact')] }}
            </td>
          </tr>
          <tr>
            <th>Primary Phone Number</th>
            <td>{{ valueOrEmpty('personalInformation.phoneNumber') | phone}} </td>
          </tr>
          <tr>
            <th>Alternate Phone Number</th>
            <td>{{ valueOrEmpty('personalInformation.alternatePhoneNumber') | phone}} </td>
          </tr>
          <tr>
            <th>Leave Voicemail?</th>
            <td>{{ enumHelper.VoicemailOptions[valueForEnum('personalInformation.leaveVoicemail')] }} </td>
          </tr>
          <tr>
            <th>Email Address</th>
            <td>{{ valueOrEmpty('personalInformation.email') }} </td>
          </tr>
          <tr>
            <th>Agree to Communication by Email</th>
            <td><span [innerHTML]="checkmarkOrEmpty('personalInformation.agreeToCvapCommunicationExchange')"></span></td>
          </tr>
          @if (formType === ApplicationType.Victim_Application) {
            <tr>
              <th>Marital Status</th>
              <td>{{ enumHelper.MaritalStatus[valueForEnum('personalInformation.maritalStatus')] }} </td>
            </tr>
          }          
        </tbody>
      </table>

      <h3>Primary Address</h3>
      <table class="table table-striped review-table">
        <tbody>
          <tr>
            <th>I do not live at the following address</th>
            <td><span [innerHTML]="checkmarkOrEmpty('personalInformation.doNotLiveAtAddress')"></span></td>
          </tr>
          @if (form.get('personalInformation.doNotLiveAtAddress').value == true) {
            <tr>
              <th>Mail Recipient</th>
              <td>{{ valueOrEmpty('personalInformation.mailRecipient') }}</td>
            </tr>
          }
          <tr>
            <th>Primary Address</th>
            <td>@if (addressHelper.hasAddressInfo(form.get('personalInformation.primaryAddress').value)) {
              <span [innerHTML]="displayMailingSubAddress('personalInformation.primaryAddress')"></span>
            }</td>
          </tr>
        </tbody>
      </table>

      @if (addressHelper.hasAddressInfo(form.get('personalInformation.alternateAddress').value)) {
        <div>
          <h3>Alternate Address</h3>
          <table class="table table-striped review-table">
            <tbody>
              <tr>
                <th>Alternate Address</th>
                <td><span [innerHTML]="displayMailingSubAddress('personalInformation.alternateAddress')"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    }
  </section>

  @if (formType === ApplicationType.IFM_Application || formType === ApplicationType.Witness_Application) {
    <section>
      <h2 class="blue-header">
        Victim Information <span class="hide-for-print"><button (click)="gotoPageIndex(pages.Victim);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
      </h2>
      <h3>Victim Name</h3>
      <table class="table table-striped review-table">
        <tbody>
          <tr>
            <th>First Name</th>
            <td>{{ valueOrEmpty('victimInformation.firstName') }} </td>
          </tr>
          <tr>
            <th>Middle Name</th>
            <td>{{ valueOrEmpty('victimInformation.middleName') }} </td>
          </tr>
          <tr>
            <th>Last Name</th>
            <td>{{ valueOrEmpty('victimInformation.lastName') }} </td>
          </tr>
          <tr>
            <th>Other First Name</th>
            <td>{{ valueOrEmpty('victimInformation.otherFirstName') }} </td>
          </tr>
          <tr>
            <th>Other Last Name</th>
            <td>{{ valueOrEmpty('victimInformation.otherLastName') }} </td>
          </tr>
          <tr>
            <th>Date of Name Change</th>
            <td>{{ datesOrEmpty(['victimInformation.dateOfNameChange']) }}</td>
          </tr>
        </tbody>
      </table>
      <h3>Other Details</h3>
      <table class="table table-striped review-table">
        <tbody>
          <tr>
            <th>Primary Phone Number</th>
            <td>{{ valueOrEmpty('victimInformation.phoneNumber') | phone}} </td>
          </tr>
          <tr>
            <th>Alternate Phone Number</th>
            <td>{{ valueOrEmpty('victimInformation.alternatePhoneNumber') | phone}} </td>
          </tr>
          <tr>
            <th>Email Address</th>
            <td>{{ valueOrEmpty('victimInformation.email') }} </td>
          </tr>
          <tr>
            <th>Birth Date</th>
            <td>{{ datesOrEmpty(['victimInformation.birthDate']) }}</td>
          </tr>
          @if (formType === ApplicationType.IFM_Application) {
            <tr>
              <th>Social Insurance Number (SIN)</th>
              <td>{{ valueOrEmpty('victimInformation.sin') }}</td>
            </tr>
          }
          <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="false">
            <th>Gender</th>
            <td>{{ enumHelper.Gender[valueForEnum('victimInformation.gender')] }} </td>
          </tr>
          <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
            <th>Gender</th>
            <td>{{ enumHelper.Gender_V2[valueForEnum('victimInformation.gender')] }} </td>
          </tr>
          <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
            <th>Other Gender</th>
            <td>{{ valueOrEmpty('victimInformation.otherGender') }} </td>
          </tr>
          <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
            <th>Pronouns</th>
            <td>{{ enumHelper.Pronouns_V2[valueForEnum('victimInformation.pronouns')] }} </td>
          </tr>
          <tr featureEnabled="useUpdatedComplianceFields" [featureEnabledIf]="true">
            <th>Other Pronouns</th>
            <td>{{ valueOrEmpty('victimInformation.otherPronouns') }} </td>
          </tr>
          <tr>
            <th>Marital Status</th>
            <td>{{ enumHelper.MaritalStatus[valueForEnum('victimInformation.maritalStatus')] }} </td>
          </tr>
          @if (formType === ApplicationType.IFM_Application) {
            <tr>
              <th>Occupation</th>
              <td>{{ valueOrEmpty('victimInformation.occupation') }} </td>
            </tr>
          }
        </tbody>
      </table>
      <h3>Most Recent Mailing Address</h3>
      <table class="table table-striped review-table">
        <tbody>
          <tr>
            <th>Is victim's mailing address the same as the applicant's primary mailing address?</th>
            <td>{{ valueOrEmpty('victimInformation.mostRecentMailingAddressSameAsPersonal') }} </td>
          </tr>
          <tr>
            <th>Mailing Address</th>
            <td>@if (addressHelper.hasAddressInfo(form.get('victimInformation.primaryAddress').value)) {
              <span [innerHTML]="displayMailingSubAddress('victimInformation.primaryAddress')"></span>
            }</td>
          </tr>
        </tbody>
      </table>
    </section>
  }

  <section>
    <h2 class="blue-header">
      Crime Information <span class="hide-for-print"><button (click)="gotoPageIndex(pages.Crime);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
    </h2>
    <h3>Crime Occurence</h3>
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>Type of Crime</th>
          <td>{{ valueOrEmpty('crimeInformation.typeOfCrime') }} </td>
        </tr>
        <tr>
          <th>When did this crime occur?</th>
          <td>
            {{ datesOrEmpty(['crimeInformation.crimePeriodStart', 'crimeInformation.crimePeriodEnd']) }}
          </td>
        </tr>
        <!-- <tr>
        <th>Is this application being filed within one year of the date of the crime?</th>
        <td>{{ valueOrEmpty('crimeInformation.overOneYearFromCrime') }} </td>
      </tr> -->
      @if (form.get('crimeInformation.overOneYearFromCrime').value === false) {
        <tr>
          <th>Why you did not apply sooner?</th>
          <td>{{ valueOrEmpty('crimeInformation.whyDidYouNotApplySooner') }} </td>
        </tr>
      }
      @for (item of crimeLocations.controls; track item; let i = $index) {
        <tr>
          <th>@if (i <= 0) {
            <span>Crime Location(s)</span>
          }</th>
          <td>{{ item.get('location').value }}</td>
        </tr>
      }
      @if (formType === ApplicationType.IFM_Application || formType === ApplicationType.Witness_Application) {
        <tr>
          <th>Is the Victim deceased as a result of the crime?</th>
          <td>{{ enumHelper.boolEnum[valueForEnum('crimeInformation.victimDeceasedFromCrime')] }} </td>
        </tr>
        @if (form.get('crimeInformation.victimDeceasedFromCrime').value == CRMBoolean.True) {
          <tr>
            <th>Date of Death</th>
            <td>{{ valueOrEmpty('crimeInformation.dateOfDeath', '') | date }} </td>
          </tr>
        }
      }
      <tr>
        <th>Crime Detail(s)</th>
        <td>{{ valueOrEmpty('crimeInformation.crimeDetails') }} </td>
      </tr>
      <tr>
        <th>Associated Injuries</th>
        <td>{{ valueOrEmpty('crimeInformation.crimeInjuries') }} </td>
      </tr>

      @for (document of form.get('crimeInformation.documents')['controls']; track document; let i = $index) {
        <tr>
          <th>Additional Information</th>
          <td>{{ valueOrEmpty(document.get('filename')) }}</td>
        </tr>
        @if (document.get('subject').value) {
          <tr>
            <th>File Description</th>
            <td>{{ valueOrEmpty(document.get('subject')) }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
  <h3>Police Involvement</h3>
  @if (form.get('crimeInformation.wasReportMadeToPolice').value === CRMMultiBoolean.False || form.get('crimeInformation.wasReportMadeToPolice').value === CRMMultiBoolean.Undecided) {
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>Was the report made to the police?</th>
          <td>
            {{enumHelper.ReportMadeToPolice[valueForEnum('crimeInformation.wasReportMadeToPolice')]}}
          </td>
        </tr>
        <tr>
          <th>Who was the report made to (e.g. doctor, social worker, counsellor, other)?</th>
          <td>{{ valueOrEmpty('crimeInformation.noPoliceReportIdentification') }} </td>
        </tr>
      </tbody>
    </table>
  }
  @if (form.get('crimeInformation.wasReportMadeToPolice').value === CRMMultiBoolean.True) {
    <section>
      <table class="table table-striped review-table">
        <tbody>
          <tr>
            <th>Was the report made to the police?</th>
            <td>{{ enumHelper.ReportMadeToPolice[valueForEnum('crimeInformation.wasReportMadeToPolice')] }}
            </td>
          </tr>
        </tbody>
      </table>
      @for (item of policeReports.controls; track item; let i = $index) {
        <table class="table table-striped review-table">
          <tbody>
            <tr>
              <th>Police Force</th>
              <td>{{ valueOrEmpty(item.get('policeDetachment')) }} @if (item.get('policeDetachment').value === 'Other') {
                <span> :
                {{ valueOrEmpty(item.get('policeDetachmentOther')) }}</span>
              }</td>
            </tr>
            <tr>
              <th>Police File Number</th>
              <td>{{ valueOrEmpty(item.get('policeFileNumber')) }} </td>
            </tr>
            <tr>
              <th>Name of Investigating Officer</th>
              <td>{{ valueOrEmpty(item.get('investigatingOfficer')) }} </td>
            </tr>
            <tr>
              <th>Date of report</th>
              @if (item.get('policeReportedMultipleTimes').value) {
                <td>
                  {{item.get('reportStartDate').value | date}} - {{item.get('reportEndDate').value | date}}
                </td>
              }
              @if (!item.get('policeReportedMultipleTimes').value) {
                <td>
                  {{item.get('reportStartDate').value | date}}
                </td>
              }
            </tr>
          </tbody>
        </table>
      }
    </section>
  }

  <h3>Offender & Court Information</h3>
  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>Offender Name</th>
        <td>{{ multiValueOrEmpty(['crimeInformation.offenderFirstName', 'crimeInformation.offenderMiddleName', 'crimeInformation.offenderLastName']) }}
        </td>
      </tr>
      <tr>
        <th>Relationship to alleged offender</th>
        <td>{{ valueOrEmpty('crimeInformation.offenderRelationship') }} </td>
      </tr>
      @for (item of form.get('crimeInformation.additionalOffenders')['controls']; track item; let i = $index) {
        <tr>
          <th>Additional Offender Name</th>
          <td>{{ multiValueOrEmpty([item.get('firstName'), item.get('middleName'), item.get('lastName')]) }}
          </td>
        </tr>
        <tr>
          <th>Relationship to alleged offender</th>
          <td>{{ valueOrEmpty(item.get('relationship')) }} </td>
        </tr>
      }
      <tr>
        <th>Has the alleged offender been charged?</th>
        <td>{{ enumHelper.OffenderBeenCharged[valueForEnum('crimeInformation.offenderBeenCharged')] }}</td>
      </tr>
      <tr>
        <th>Have you sued the Person(s) Responsible?</th>
        <td>{{ enumHelper.HaveYouSuedOffender[valueForEnum('crimeInformation.haveYouSuedOffender')] }}</td>

      </tr>
      @if (form.get('crimeInformation.haveYouSuedOffender').value === CRMBoolean.False) {
        <tr>
          <th>Do you intend to sue the Person(s) Responsible?</th>
          <td>{{ enumHelper.IntendToSueOffender[valueForEnum('crimeInformation.intendToSueOffender')] }}</td>
        </tr>
      }
    </tbody>
  </table>
  @if (form.get('crimeInformation.offenderBeenCharged').value === CRMMultiBoolean.True) {
    @for (item of courtFiles.controls; track item; let i = $index) {
      <table class="table table-striped review-table">
        <tbody>
          <tr>
            <th>Court File Number</th>
            <td>{{ valueOrEmpty(item.get('courtFileNumber')) }} </td>
          </tr>
          <tr>
            <th>Court Location</th>
            <td>{{ valueOrEmpty(item.get('courtLocation')) }} </td>
          </tr>
        </tbody>
      </table>
    }
  }
  @if (form.get('crimeInformation.haveYouSuedOffender').value === CRMBoolean.True || form.get('crimeInformation.intendToSueOffender').value === CRMMultiBoolean.True || form.get('crimeInformation.intendToSueOffender').value === CRMMultiBoolean.Undecided) {
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>Did you apply to the court for money from the offender?</th>
          <td>{{ enumHelper.ApplyToCourtForMoneyFromOffender[valueForEnum('crimeInformation.racafInformation.applyToCourtForMoneyFromOffender')] }}
          </td>
        </tr>
        @if (form.get('crimeInformation.racafInformation.applyToCourtForMoneyFromOffender').value === CRMMultiBoolean.True) {
          <tr>
            <th>What expenses did you ask to be covered?</th>
            <td>{{ valueOrEmpty('crimeInformation.racafInformation.expensesRequested') }} </td>
          </tr>
          <tr>
            <th>Amount awarded by the judge</th>
            <td>{{ valueOrEmpty('crimeInformation.racafInformation.expensesAwarded', '') | currency}} </td>
          </tr>
          <tr>
            <th>Amount Received</th>
            <td>{{ valueOrEmpty('crimeInformation.racafInformation.expensesReceived', '') | currency}} </td>
          </tr>
        }
        <tr>
          <th>Have you taken, or will you be taking, legal action?</th>
          <td>{{ enumHelper.WillBeTakingLegalAction[valueForEnum('crimeInformation.racafInformation.willBeTakingLegalAction')] }}
          </td>
        </tr>
        @if (form.get('crimeInformation.racafInformation.willBeTakingLegalAction').value === CRMMultiBoolean.True) {
          <tr>
            <th>Do you have a lawyer?</th>
            <td>{{ enumHelper.boolEnum[valueForEnum('crimeInformation.racafInformation.haveLawyer')] }} </td>
          </tr>
        }
        @if (form.get('crimeInformation.racafInformation.haveLawyer').value === CRMBoolean.True) {
          <tr>
            <th>Lawyer or Law Firm Name</th>
            <td>{{ valueOrEmpty('crimeInformation.racafInformation.lawyerOrFirmName') }} </td>
          </tr>
          <tr>
            <th>Lawyer Address</th>
            <td>@if (addressHelper.hasAddressInfo(form.get('crimeInformation.racafInformation.lawyerAddress').value)) {
              <span [innerHTML]="addressHelper.displayAddress(form.get('crimeInformation.racafInformation.lawyerAddress').value)"></span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
@if (form.get('crimeInformation.racafInformation.applyToCourtForMoneyFromOffender').value === CRMMultiBoolean.True || form.get('crimeInformation.racafInformation.willBeTakingLegalAction').value === CRMMultiBoolean.True) {
  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>Applicant's Name</th>
        <td>{{ valueOrEmpty('crimeInformation.racafInformation.signName') }} </td>
      </tr>
      <tr>
        <th>Applicant's Signature</th>
        <td>@if (valueOrEmpty('crimeInformation.racafInformation.signature', '') != '') {
          <img class="review-signature" [src]="valueOrEmpty('crimeInformation.racafInformation.signature', '')" alt="Digital signature" />
        }</td>
      </tr>
    </tbody>
  </table>
}
</section>

<section>
  <h2 class="blue-header">
    Medical @if (formType === ApplicationType.Victim_Application) {
    <span>& Dental </span>
    }Information <span class="hide-for-print"><button (click)="gotoPageIndex(pages.Medical);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
  </h2>
  <h3>Coverage</h3>
  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>Do you have provincial medical services coverage?</th>
        <td>{{ valueOrEmpty('medicalInformation.doYouHaveMedicalServicesCoverage') }} </td>
      </tr>
      @if (form.get('medicalInformation.doYouHaveMedicalServicesCoverage').value === true) {
        <tr>
          <th>Personal Health Number</th>
          <td>{{ valueOrEmpty('medicalInformation.personalHealthNumber') }} </td>
        </tr>
        <tr>
          <th>Province</th>
          <td>{{ valueOrEmpty('medicalInformation.haveMedicalCoverageProvince') }} </td>
        </tr>
        @if (form.get('medicalInformation.haveMedicalCoverageProvince').value === 'Other') {
          <tr>
            <th>Other</th>
            <td>{{ valueOrEmpty('medicalInformation.haveMedicalCoverageProvinceOther') }} </td>
          </tr>
        }
      }

      <tr>
        <th>Do you have other health coverage?</th>
        <td>{{ enumHelper.boolEnum[valueForEnum('medicalInformation.doYouHaveOtherHealthCoverage')] }} </td>
      </tr>
      @if (form.get('medicalInformation.doYouHaveOtherHealthCoverage').value === CRMBoolean.True) {
        <tr>
          <th>Name of provider</th>
          <td>{{ valueOrEmpty('medicalInformation.otherHealthCoverageProviderName') }} </td>
        </tr>
        <tr>
          <th>Extended Health Plan Number</th>
          <td>{{ valueOrEmpty('medicalInformation.otherHealthCoverageExtendedPlanNumber') }} </td>
        </tr>
      }
    </tbody>
  </table>

  <h3>Treatment</h3>
  <table class="table table-striped review-table">
    <tbody>
      @if (formType === ApplicationType.Victim_Application) {
        <tr>
          <th>Did you go to a hospital to be treated for injuries resulting from the incident?</th>
          <td>{{ valueOrEmpty('medicalInformation.wereYouTreatedAtHospital') }} </td>
        </tr>
        @if (form.get('medicalInformation.wereYouTreatedAtHospital').value === true) {
          @if (form.get('medicalInformation.treatedOutsideBc').value !== true) {
            <tr>
              <th>Name of hospital</th>
              <td>{{ valueOrEmpty('medicalInformation.treatedAtHospitalName') }} </td>
            </tr>
          }
          <tr>
            <th>Is the hospital outside of BC?</th>
            <td>{{ valueOrEmpty('medicalInformation.treatedOutsideBc') }} </td>
          </tr>
          @if (form.get('medicalInformation.treatedOutsideBc').value === true) {
            <tr>
              <th>Please enter the name of the hospital</th>
              <td>{{ valueOrEmpty('medicalInformation.treatedOutsideBcHospitalName') }} </td>
            </tr>
          }
          <tr>
            <th>Date of treatment</th>
            <td>{{ datesOrEmpty(['medicalInformation.treatedAtHospitalDate']) }}</td>
          </tr>
        }
      }

      <tr>
        <th>Do you have a medical doctor / clinic who has been treating you for injuries resulting from the
        incident?</th>
        <td>{{ valueOrEmpty('medicalInformation.beingTreatedByFamilyDoctor') }} </td>
      </tr>
      @if (form.get('medicalInformation.beingTreatedByFamilyDoctor').value === true) {
        <tr>
          <th>Name of Clinic</th>
          <td>{{ valueOrEmpty('medicalInformation.familyDoctorClinic') }} </td>
        </tr>
        <tr>
          <th>Email Address</th>
          <td>{{ valueOrEmpty('medicalInformation.familyDoctorEmail') }} </td>
        </tr>
        <tr>
          <th>Doctor Name</th>
          <td>{{ valueOrEmpty('medicalInformation.familyDoctorFirstName') }}
            {{ valueOrEmpty('medicalInformation.familyDoctorLastName', '') }}
          </td>
        </tr>
        <!-- <tr>
        <th>Email Address</th>
        <td>{{ valueOrEmpty('medicalInformation.familyDoctorEmail') }} </td>
      </tr> -->
      <tr>
        <th>Family doctor's Phone Number</th>
        <td>{{ valueOrEmpty('medicalInformation.familyDoctorPhoneNumber') | phone}} </td>
      </tr>
      @if (form.get('medicalInformation.familyDoctorFax').value) {
        <tr>
          <th>Family doctor's Fax Number</th>
          <td>{{ valueOrEmpty('medicalInformation.familyDoctorFax') | phone}} </td>
        </tr>
      }
      <tr>
        <th>Mailing Address</th>
        <td>@if (addressHelper.hasAddressInfo(form.get('medicalInformation.familyDoctorAddress').value)) {
          <span [innerHTML]="addressHelper.displayAddress(form.get('medicalInformation.familyDoctorAddress').value)"></span>
        }</td>
      </tr>
    }

    <tr>
      <th>Have you seen any other doctors, specialists, or counsellors who have been treating you for
      injuries resulting from the incident?</th>
      <td>{{ valueOrEmpty('medicalInformation.hadOtherTreatments') }} </td>
    </tr>
  </tbody>
</table>
@for (item of otherMedicalTreatments.controls; track item; let i = $index) {
  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>Type</th>
        <td>{{ item.get('providerType').value }}</td>
      </tr>
      <tr>
        <th>Name of Company/Organization</th>
        <td>{{ item.get('providerCompany').value }}</td>
      </tr>
      <tr>
        <th>Email</th>
        <td>{{ valueOrEmpty(item.get('providerEmail')) }}</td>
      </tr>
      <tr>
        <th>Provider Name</th>
        <td>{{ valueOrEmpty(item.get('providerFirstName')) }}
        {{ valueOrEmpty(item.get('providerLastName'), '') }}</td>
      </tr>
      <tr>
        <th>Phone</th>
        <td>{{ item.get('providerPhoneNumber').value | phone}}</td>
      </tr>
      <tr>
        <th>Fax</th>
        <td>{{ valueOrEmpty(item.get('providerFax')) | phone}}</td>
      </tr>
      @if (formType === ApplicationType.Victim_Application) {
        <tr>
          <th>Type of provider</th>
          <td>{{ item.get('providerType').value }}@if (item.get('providerType').value === 'Other') {
            <span> : {{item.get('providerTypeText').value}}</span>
          }</td>
        </tr>
      }
      <tr>
        <th>Mailing Address</th>
        <td>@if (addressHelper.hasAddressInfo(item.get('providerAddress').value)) {
          <span [innerHTML]="addressHelper.displayAddress(item.get('providerAddress').value)"></span>
        }</td>
      </tr>
    </tbody>
  </table>
}
</section>

<section>
  <h2 class="blue-header">
    Expense and {{formType===ApplicationType.Victim_Application ? 'Loss': 'Benefits'}}<span class="hide-for-print"><button (click)="gotoPageIndex(pages.Expense);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
  </h2>
  <h3>Benefits Available Through CVAP</h3>
  <table class="table table-striped review-table">
    <tbody>
      @if (formType === ApplicationType.Victim_Application) {
        <tr>
          <th>Medical expenses</th>
          <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveMedicalExpenses')"></span></td>
        </tr>
        <tr>
          <th>Dental expenses</th>
          <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveDentalExpenses')"></span></td>
        </tr>
        <tr>
          <th>Prescription drug expenses</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.havePrescriptionDrugExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>Counselling</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCounsellingExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>Lost employment income (reimbursed at minimum wage)</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveLostEmploymentIncomeExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>
            Repair or replacement costs of damaged or destroyed personal property that you were wearing
            at the time of the incident (e.g. eyeglasses, clothing)
          </th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.havePersonalPropertyLostExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>Protective Measures for Security Devices</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveProtectiveMeasureExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>Protective Measures for Moving Expenses</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveProtectiveMovingExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>Transportation to Obtain Benefits</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveTransportationToObtainBenefits')"></span>
          </td>
        </tr>
        <tr>
          <th>Disability benefits, services or equipment</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveDisabilityExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>Crime scene cleaning</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCrimeSceneCleaningExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>Other</th>
          <td>
            <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveOtherExpenses')"> </span> @if (form.get('expenseInformation.haveOtherExpenses').value === true) {
            <span>
              {{ valueOrEmpty('expenseInformation.otherSpecificExpenses') }}
            </span>
          }
        </td>
      </tr>
      <tr>
        <th>Additional Details</th>
        <td>{{valueOrEmpty('expenseInformation.additionalBenefitsDetails')}}</td>
      </tr>
    }
    @if (formType === ApplicationType.IFM_Application || formType === ApplicationType.Witness_Application) {
      <tr>
        <th>Counselling</th>
        <td>
          <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCounsellingExpenses')"></span>
        </td>
      </tr>
      <tr>
        <th>Transportation to obtain counselling</th>
        <td>
          <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCounsellingTransportation')"></span>
        </td>
      </tr>
      <tr>
        <th>Prescription drug expenses</th>
        <td>
          <span [innerHTML]="checkmarkOrEmpty('expenseInformation.havePrescriptionDrugExpenses')"></span>
        </td>
      </tr>
      <tr>
        <th>Crime scene cleaning</th>
        <td>
          <span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCrimeSceneCleaningExpenses')"></span>
        </td>
      </tr>
      <tr>
        <th>Additional Details</th>
        <td>{{valueOrEmpty('expenseInformation.additionalBenefitsDetails')}}</td>
      </tr>
    }
  </tbody>
</table>

@if (formType === ApplicationType.Victim_Application) {
  <h3>Other Benefits</h3>
  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>Disability Plan benefits</th>
        <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveDisabilityPlanBenefits')"></span>
      </td>
    </tr>
    <tr>
      <th>Employment Insurance benefits</th>
      <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveEmploymentInsuranceBenefits')"></span>
    </td>
  </tr>
  <tr>
    <th>Income Assistance</th>
    <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveIncomeAssistanceBenefits')"></span>
  </td>
</tr>
<tr>
  <th>Canada Pension Plan</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCanadaPensionPlanBenefits')"></span>
</td>
</tr>
<tr>
  <th>Indigenous Services Canada</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveAboriginalAffairsAndNorthernDevelopmentCanadaBenefits')"></span>
</td>
</tr>
<tr>
  <th>Benefits you have received as a result of civil action</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCivilActionBenefits')"></span>
</td>
</tr>
<tr>
  <th>Other</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveOtherBenefits')"></span> @if (form.get('expenseInformation.haveOtherBenefits').value === true) {
  <span>
  {{ valueOrEmpty('expenseInformation.otherSpecificBenefits') }}</span>
}</td>
</tr>
</tbody>
</table>
}

@if (formType === ApplicationType.IFM_Application || formType === ApplicationType.Witness_Application) {
  @if (form.get('crimeInformation.victimDeceasedFromCrime').value == CRMBoolean.True) {
    <section>
      @if (formType === ApplicationType.IFM_Application) {
        <h3>Additional Benefits</h3>
        <table class="table table-striped review-table">
          <tbody>
            <tr>
              <th>Vocational services or training</th>
              <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveVocationalServicesExpenses')"></span>
            </td>
          </tr>
          <tr>
            <th>Income support</th>
            <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveIncomeSupportExpenses')"></span>
          </td>
        </tr>
        <tr>
          <th>Childcare</th>
          <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveChildcareExpenses')"></span>
        </td>
      </tr>
      <tr>
        <th>Transportation to attend legal proceedings</th>
        <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveLegalProceedingExpenses')"></span>
      </td>
    </tr>
    <tr>
      <th>Funeral expenses</th>
      <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveFuneralExpenses')"></span>
    </td>
  </tr>
  <tr>
    <th>Bereavement leave</th>
    <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveBereavementLeaveExpenses')"></span>
  </td>
</tr>
<tr>
  <th>Loss of parental guidance</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveLostOfParentalGuidanceExpenses')"></span>
</td>
</tr>
<tr>
  <th>Homemaker services</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveHomeMakerExpenses')"></span>
</td>
</tr>
</tbody>
</table>
<section>
  <h2 class="blue-header">Employment Income </h2>
  <h3>Income Loss Information</h3>
  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>Have you missed work as a result of the death of the victim?</th>
        <td>{{ enumHelper.boolEnum[valueForEnum('expenseInformation.missedWorkDueToDeathOfVictim')] }}
        </td>
      </tr>
      @if (form.get('expenseInformation.missedWorkDueToDeathOfVictim').value === CRMBoolean.True) {
        <tr>
          <th>Did you lose wages during the eligible period?</th>
          <td>{{ enumHelper.boolEnum[valueForEnum('expenseInformation.didYouLoseWages')] }}
          </td>
        </tr>
        <tr>
          <th>Please provide days of work missed</th>
          <td>{{ valueOrEmpty('expenseInformation.daysWorkMissedStart', '') | date}} -
          {{ valueOrEmpty('expenseInformation.daysWorkMissedEnd', '') | date}} </td>
        </tr>
        <tr>
          <th>Social Insurance Number (SIN)</th>
          <td>{{ valueOrEmpty('expenseInformation.sin') }} </td>
        </tr>
      }
    </tbody>
  </table>
  @if (form.get('expenseInformation.missedWorkDueToDeathOfVictim').value === CRMBoolean.True) {
    <h3>Employer Information</h3>
    @for (item of employers.controls; track item; let i = $index) {
      <table class="table table-striped review-table">
        <tbody>
          <tr>
            <th>If you are requesting benefits for lost wages, may we contact your employer?
            </th>
            <td>{{ enumHelper.boolEnum[valueForEnum('expenseInformation.mayContactEmployer')] }} </td>
          </tr>
          <tr>
            <th>Name of Company/Organization</th>
            <td>{{ valueOrEmpty(item.get('employerName')) }}</td>
          </tr>
          <tr>
            <th>Employer Email</th>
            <td>{{ valueOrEmpty(item.get('employerEmail')) }}</td>
          </tr>
          <tr>
            <th>Contact Name</th>
            <td>{{ valueOrEmpty(item.get('employerFirstName')) }}
            {{ valueOrEmpty(item.get('employerLastName'), '') }}</td>
          </tr>
          <tr>
            <th>Phone Number of Contact Person</th>
            <td>{{ valueOrEmpty(item.get('employerPhoneNumber')) | phone}}</td>
          </tr>
          <tr>
            <th>Fax</th>
            <td>{{ valueOrEmpty(item.get('employerFax')) | phone}}</td>
          </tr>
          <tr>
            <th>Mailing Address</th>
            <td>@if (addressHelper.hasAddressInfo(item.get('employerAddress').value)) {
              <span [innerHTML]="displayMailingAddress(item.get('employerAddress'))"></span>
            }
          </td>
        </tr>
      </tbody>
    </table>
  }
}
</section>
<h3>Other Benefits</h3>
<table class="table table-striped review-table">
  <tbody>
    <tr>
      <th>Life insurance/death benefits</th>
      <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveLifeInsuranceBenefits')"></span>
    </td>
  </tr>
  <tr>
    <th>Disability Plan benefits</th>
    <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveDisabilityPlanBenefits')"></span>
  </td>
</tr>
<tr>
  <th>Employment Insurance benefits</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveEmploymentInsuranceBenefits')"></span>
</td>
</tr>
<tr>
  <th>Income Assistance</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveIncomeAssistanceBenefits')"></span>
</td>
</tr>
<tr>
  <th>Canada Pension Plan</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCanadaPensionPlanBenefits')"></span>
</td>
</tr>
<tr>
  <th>Indigenous Services Canada</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveAboriginalAffairsAndNorthernDevelopmentCanadaBenefits')"></span>
</td>
</tr>
<tr>
  <th>Benefits you have received as a result of civil action</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveCivilActionBenefits')"></span>
</td>
</tr>
<tr>
  <th>Other</th>
  <td><span [innerHTML]="checkmarkOrEmpty('expenseInformation.haveOtherBenefits')"></span>
  @if (form.get('expenseInformation.haveOtherBenefits').value === true) {
    <span>
    {{ valueOrEmpty('expenseInformation.otherSpecificBenefits') }}</span>
  }
</td>
</tr>
</tbody>
</table>
}
</section>
}
}
</section>

@if (formType === ApplicationType.Victim_Application) {
  <section>
    <h2 class="blue-header">
      Employment Income <span class="hide-for-print"><button (click)="gotoPageIndex(pages.Employment);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
    </h2>
    <h3>Income Loss Information</h3>
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>Were you employed when the crime occured?</th>
          <td>{{ enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.wereYouEmployedAtTimeOfCrime')] }}
          </td>
        </tr>
        @if (enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.wereYouEmployedAtTimeOfCrime')] === 'Yes') {
          <tr>
            <th>Were you at work at the time of the incident?</th>
            <td>{{ enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.wereYouAtWorkAtTimeOfIncident')] }}
            </td>
          </tr>
          <tr>
            <th>Have you applied to WorkSafe BC?</th>
            <td>{{ enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.haveYouAppliedToWorkSafe')] }}
            </td>
          </tr>
          <tr>
            <th>WorkSafe BC Claim #</th>
            <td>{{ valueOrEmpty('employmentIncomeInformation.workersCompensationClaimNumber') }} </td>
          </tr>
        }
        <tr>
          <th>As a result of any crime-related injuries, did you miss work?</th>
          <td>{{ enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.didYouMissWorkDueToCrime')] }}
          </td>
        </tr>
        @if (enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.didYouMissWorkDueToCrime')] === 'Yes') {
          <tr>
            <th>Are you currently off work?</th>
            <td>{{ enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.areYouStillOffWork')] }}
            </td>
          </tr>
          <tr>
            <th>Please provide date(s) of work missed</th>
            <td>{{ valueOrEmpty('employmentIncomeInformation.daysWorkMissedStart', '') | date}} -
              @if (form.get('employmentIncomeInformation.areYouStillOffWork').value === CRMBoolean.True) {
                <span>Present</span>
              }
              @if (form.get('employmentIncomeInformation.areYouStillOffWork').value === CRMBoolean.False) {
                <span>{{ valueOrEmpty('employmentIncomeInformation.daysWorkMissedEnd', '') | date}}</span>
              }
            </td>
          </tr>
          <tr>
            <th>As a result of any crime-related injuries, did you lose wages?</th>
            <td>{{ enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.didYouLoseWages')] }} </td>
          </tr>
          <tr>
            <th>Social Insurance Number (SIN)</th>
            <td>{{ valueOrEmpty('employmentIncomeInformation.sin') }} </td>
          </tr>
        }
      </tbody>
    </table>
    @if (enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.didYouLoseWages')] === 'Yes') {
      <div>
        <h3>Income Loss Information</h3>
        <table class="table table-striped review-table">
          <tbody>
            <tr>
              <th>Are you self employed?</th>
              <td>{{ enumHelper.boolEnum[valueForEnum('employmentIncomeInformation.areYouSelfEmployed')] }}
              </td>
            </tr>
          </tbody>
        </table>
        @for (item of employers.controls; track item; let i = $index) {
          <table class="table table-striped review-table">
            <tbody>
              @if (form.get('employmentIncomeInformation.areYouSelfEmployed').value !== CRMBoolean.True) {
                <tr>
                  <th>If you are requesting benefits for lost wages, may we contact your employer?</th>
                  <td>{{ enumHelper.boolEnum[valueForEnum(item.get('contactable'))] }} </td>
                </tr>
              }
              <tr>
                <th>Name of Company/Organization</th>
                <td>{{ valueOrEmpty(item.get('employerName')) }}</td>
              </tr>
              <tr>
                <th>Employer email</th>
                <td>{{ valueOrEmpty(item.get('employerEmail')) }}</td>
              </tr>
              <tr>
                <th>Contact Name</th>
                <td>{{ valueOrEmpty(item.get('employerFirstName')) }}
                {{ valueOrEmpty(item.get('employerLastName'), '') }}</td>
              </tr>
              <tr>
                <th>Phone Number of Contact Person</th>
                <td>{{ valueOrEmpty(item.get('employerPhoneNumber')) | phone}}</td>
              </tr>
              @if (item.get('employerFax').value) {
                <tr>
                  <th>Fax</th>
                  <td>{{ valueOrEmpty(item.get('employerFax')) | phone}}</td>
                </tr>
              }
              <tr>
                <th>Mailing Address</th>
                <td>@if (addressHelper.hasAddressInfo(item.get('employerAddress').value)) {
                  <span [innerHTML]="displayMailingAddress(item.get('employerAddress'))"></span>
                }</td>
              </tr>
            </tbody>
          </table>
        }
        <table class="table table-striped review-table">
          <tbody>
            @for (document of form.get('employmentIncomeInformation.documents')['controls']; track document; let i = $index) {
              <tr>
                <th>Additional Information</th>
                <td>{{ valueOrEmpty(document.get('filename')) }}</td>
              </tr>
              @if (document.get('subject').value) {
                <tr>
                  <th>File Description</th>
                  <td>{{ valueOrEmpty(document.get('subject')) }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
  </section>
}

<section>
  <h2 class="blue-header">
    Application on Behalf of the Victim <span class="hide-for-print"><button (click)="gotoPageIndex(pages.OnBehalfOf);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
  </h2>
  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>I am:</th>
        <td>{{ enumHelper.CompletingOnBehalfOf[valueForEnum('representativeInformation.completingOnBehalfOf')] }}
        </td>
      </tr>
      @if (form.get('representativeInformation.completingOnBehalfOf').value === OnBehalfOf.Legal_Guardian) {
        <tr>
          <th>Relationship to Person</th>
          <td>{{ valueOrEmpty('representativeInformation.relationshipToPerson') }}</td>
        </tr>
      }
    </tbody>
  </table>

  @if (form.get('representativeInformation.completingOnBehalfOf').value !== OnBehalfOf.Myself) {
    <h3>Name</h3>
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>First Name</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeFirstName') }}</td>
        </tr>
        <tr>
          <th>Middle Name</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeMiddleName') }}</td>
        </tr>
        <tr>
          <th>Last Name</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeLastName') }}</td>
        </tr>
      </tbody>
    </table>
    <h3>Contact Information</h3>
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>Preferred Method of Contact</th>
          <td>{{ enumHelper.ParticipantPreferredMethodOfContact[valueForEnum('representativeInformation.representativePreferredMethodOfContact')] }}
          </td>
        </tr>
        <tr>
          <th>Phone Number</th>
          <td>{{ valueOrEmpty('representativeInformation.representativePhoneNumber') | phone}}</td>
        </tr>
        <tr>
          <th>Phone Number</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeAlternatePhoneNumber') | phone}}
          </td>
        </tr>
        <tr>
          <th>Email Address</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeEmail') }} </td>
        </tr>
      </tbody>
    </table>
    <h3>Mailing Address</h3>
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>Mailing Address</th>
          <td>{{ multiValueOrEmpty(['representativeInformation.representativeAddress.line1']) }}</td>
        </tr>
        @if (valueOrEmpty('representativeInformation.representativeAddress.line2') != '--') {
          <tr>
            <th></th>
            <td>{{ valueOrEmpty('representativeInformation.representativeAddress.line2') }} </td>
          </tr>
        }
        <tr>
          <th>City</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeAddress.city') }}</td>
        </tr>
        <tr>
          <th>Province</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeAddress.province') }}</td>
        </tr>
        <tr>
          <th>Postal Code</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeAddress.postalCode') }}</td>
        </tr>
        <tr>
          <th>Country</th>
          <td>{{ valueOrEmpty('representativeInformation.representativeAddress.country') }}</td>
        </tr>
      </tbody>
    </table>
    @if (form.get('representativeInformation.completingOnBehalfOf').value === OnBehalfOf.Legal_Guardian) {
      <table class="table table-striped review-table">
        <tbody>
          @for (document of form.get('representativeInformation.documents')['controls']; track document; let i = $index) {
            <tr>
              <th>Proof of Legal Authority</th>
              <td>{{ valueOrEmpty(document.get('filename')) }}</td>
            </tr>
            @if (document.get('subject').value) {
              <tr>
                <th>File Description</th>
                <td>{{ valueOrEmpty(document.get('subject')) }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
  }
</section>

<section>
  <h2 class="blue-header">
    Declaration <span class="hide-for-print"><button (click)="gotoPageIndex(pages.Declaration);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
  </h2>
  @if (form.get('declarationInformation.declaredAndSigned').value === true) {
    <div>
      <p>
        <label class="inline-label inline-checkbox-label">
          <input type="checkbox" [checked]="form.get('declarationInformation.declaredAndSigned').value === true" disabled="disabled" />
          <span>I submit this application in support of a claim for benefits available to Victims under the
            Crime Victim Assistance Act, and declare the information provided in this application for
          benefits is true and correct.</span>
        </label>
      </p>
    </div>
  }

  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>Applicant's Signature</th>
        <td>
          @if (valueOrEmpty('declarationInformation.signature', '') != '') {
            <img class="review-signature" [src]="valueOrEmpty('declarationInformation.signature', '')" alt="Digital signature" />
          }
        </td>
      </tr>
    </tbody>
  </table>
</section>

<section>
  <h2 class="blue-header">
    Authorization <span class="hide-for-print"><button (click)="gotoPageIndex(pages.Authorization);" class="btn review-btn"><i class="fa fa-pencil"></i> VIEW AND EDIT</button></span>
  </h2>
  @if (form.get('authorizationInformation.approvedAuthorityNotification').value === true) {
    <div>
      <p>
        <label class="inline-label inline-checkbox-label">
          <input type="checkbox" [checked]="form.get('authorizationInformation.approvedAuthorityNotification').value === true" disabled="disabled" />
          <span>I understand that the Crime Victim Assistance Program may notify the above authorities that I
          have submitted an application for benefits pursuant to the Crime Victim Assistance Act.</span>
        </label>
      </p>
    </div>
  }
  @if (form.get('authorizationInformation.readAndUnderstoodTermsAndConditions').value === true) {
    <div>
      <p>
        <label class="inline-label inline-checkbox-label">
          <input type="checkbox" [checked]="form.get('authorizationInformation.readAndUnderstoodTermsAndConditions').value === true" disabled="disabled" />
          <span>I have read and understood the above information.</span>
        </label>
      </p>
    </div>
  }

  <table class="table table-striped review-table">
    <tbody>
      <tr>
        <th>Applicant's Signature</th>
        <td>@if (valueOrEmpty('authorizationInformation.signature', '') != '') {
          <img class="review-signature" [src]="valueOrEmpty('authorizationInformation.signature', '')" alt="Digital signature" />
        }</td>
      </tr>
      <tr>
        <th>Optional authorization given?</th>
        <td>{{ enumHelper.boolEnum[valueForEnum('authorizationInformation.allowCvapStaffSharing')] }} </td>
      </tr>
    </tbody>
  </table>

  @if (form.get('authorizationInformation.allowCvapStaffSharing').value === CRMBoolean.True) {
    <div>
      <h3>Optional Authorization</h3>
      @for (item of form.get('authorizationInformation.authorizedPerson')['controls']; track item; let i = $index) {
        <table class="table table-striped review-table">
          <tbody>
            <tr>
              <th>Type</th>
              <td>{{ valueOrEmpty(item.get('providerType')) }} </td>
            </tr>
            @if (item.get('providerType').value === 'Agency') {
              <tr>
                <th>Agency Name</th>
                <td>{{ valueOrEmpty(item.get('authorizedPersonAgencyName')) }}</td>
              </tr>
            }
            <tr>
              <th>Email Address</th>
              <td>{{ valueOrEmpty(item.get('authorizedPersonEmail')) }}</td>
            </tr>
            <tr>
              <th>Full Name</th>
              <td>{{ valueOrEmpty(item.get('authorizedPersonFirstName')) }}
              {{ valueOrEmpty(item.get('authorizedPersonLastName')) }}</td>
            </tr>
            <tr>
              <th>Relationship to Applicant</th>
              <td>{{ valueOrEmpty(item.get('authorizedPersonRelationship')) }} @if (item.get('authorizedPersonRelationship').value === 'Other') {
                <span> :
                {{ valueOrEmpty(item.get('authorizedPersonRelationshipOther')) }}</span>
              }</td>
            </tr>
            <tr>
              <th>Phone Number</th>
              <td>{{ valueOrEmpty(item.get('authorizedPersonPhoneNumber')) | phone}}</td>
            </tr>
            @if (addressHelper.hasAddressInfo(item.get('authorizedPersonAgencyAddress').value)) {
              <tr>
                <th>Mailing Address</th>
                <td><span [innerHTML]="displayMailingAddress(item.get('authorizedPersonAgencyAddress'))"></span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    @if (form.get('authorizationInformation.authorizedPersonAuthorizesDiscussion').value === true) {
      <div>
        <p>
          <label class="inline-label inline-checkbox-label">
            <input type="checkbox" [checked]="form.get('authorizationInformation.authorizedPersonAuthorizesDiscussion').value === true" disabled="disabled" />
            <span>I hereby authorize the Crime Victim Assistance Program staff to discuss my claim with the
            above named authorized person(s).</span>
          </label>
        </p>
      </div>
    }
    <table class="table table-striped review-table">
      <tbody>
        <tr>
          <th>Applicant's Signature</th>
          <td>@if (valueOrEmpty('authorizationInformation.authorizedPersonSignature', '') != '') {
            <img class="review-signature" [src]="valueOrEmpty('authorizationInformation.authorizedPersonSignature', '')" alt="Digital signature" />
          }
        </td>
      </tr>
    </tbody>
  </table>
</div>
}
</section>



</div>

